import { callbacks, setCallback } from './callbacks';
import { initEnvironment } from './appEnvironment';
import utils from '../scripts/utils';
import log from './logger';
import miniapp from '../model/miniapp';
import operation from '../constants/operationType';

const UNDEFINED = "undefined";
let config;

const askMeSetup = (callback) => {
    setCallback("afterSetup", callback);

    if (typeof Cielo !== UNDEFINED) {
        Cielo.askMeSetup();
    } else if (typeof window.webkit !== UNDEFINED) {
        window.webkit.messageHandlers.askMeSetup.postMessage("");
    }
}

const willSetup = (data) => {
    config = utils.fromStringToJson(data);
    initEnvironment(config);

    const analyticsData = log.formatAnalyticsData(
        config.platform,
        config.miniAppName,
        config.miniAppId,
        config.userName,
        operation.AUTHENTICATION
    );

    if (!utils.isSetupDefined()) {
        log.logAction(analyticsData, afterSetup);
        utils.defineSetup();
    } else {
        afterSetup();
    }
}

const afterSetup = () => {
    miniapp.miniappName = config.miniAppName;
    miniapp.miniappId = config.miniAppId;
    miniapp.platform = config.platform;
    miniapp.username = config.userName;

    console.log("Configuração efetuada com sucesso!");
    callbacks.afterSetup(config);
}

const initSetup = () => {
    window.willSetup = willSetup;
}

export { askMeSetup, initSetup };